"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChargesBreakdown = exports.getTotalPositiveCharge = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var core_1 = require("../../../../../../../shared/core");
var copy_1 = require("../../../../../copy");
var billing_1 = require("../../../../../utils/billing");
function capitaliseFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function IconWithChildren(_a) {
    var Icon = _a.Icon, children = _a.children;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        Icon,
        " ",
        children));
}
function getTotalPositiveCharge(period) {
    var total = 0;
    if (period.electricity) {
        var elecConsumptionCharge = Number(period.electricity.consumption.netCharge.pounds);
        if (elecConsumptionCharge > 0) {
            total += elecConsumptionCharge;
        }
        var elecStandingCharge = Number(period.electricity.standing.netCharge.pounds);
        if (elecStandingCharge > 0) {
            total += elecStandingCharge;
        }
    }
    if (period.gas) {
        var gasConsumptionCharge = Number(period.gas.consumption.netCharge.pounds);
        if (gasConsumptionCharge > 0) {
            total += gasConsumptionCharge;
        }
        var gasStandingCharge = Number(period.gas.standing.netCharge.pounds);
        if (gasStandingCharge > 0) {
            total += gasStandingCharge;
        }
    }
    var vat = Number(period.totalCharge.vatCharge.pounds);
    if (vat > 0) {
        total += vat;
    }
    // check all upgrades for charges
    var upgradeTotal = period.upgrades.reduce(function (runningTotal, upgrade) {
        if (Number(upgrade.grossCharge.pounds) > 0) {
            runningTotal += Number(upgrade.grossCharge.pounds);
        }
        return runningTotal;
    }, 0);
    total += upgradeTotal;
    // check transactions for negative credits added
    var transactionTotal = period.transactions.reduce(function (runningTotal, transaction) {
        // Note: checking for negative transactions (ie money added onto account debt)
        if (Number(transaction.netCredit.pounds) < 0) {
            // Note running total takes away the negative amount so the running total becomes positive
            runningTotal -= Number(transaction.netCredit.pounds);
        }
        return runningTotal;
    }, 0);
    total += transactionTotal;
    return total;
}
exports.getTotalPositiveCharge = getTotalPositiveCharge;
function getPercentageString(charge, total) {
    return "".concat(Math.round((charge / total) * 100), "%");
}
var useChargesBreakdown = function (period) {
    var colors = (0, styled_components_1.useTheme)().colors;
    var Icon = (0, core_1.useComponents)().Icon;
    var _a = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _a.copy, Copy = _a.Copy;
    var totalCharge = Number(period.totalCharge.grossCharge.pounds);
    var totalPositiveCharge = getTotalPositiveCharge(period);
    var closingBalance = period.closingBalance.pounds;
    var elecSpendString = (0, core_1.major2DP)((0, core_1.majorToMinor)((0, billing_1.getTotalFuelCharge)(period.electricity)));
    var gasSpendString = (0, core_1.major2DP)((0, core_1.majorToMinor)((0, billing_1.getTotalFuelCharge)(period.gas)));
    var elecPercentage = getPercentageString((0, billing_1.getTotalFuelCharge)(period.electricity), totalPositiveCharge);
    var gasPercentage = getPercentageString((0, billing_1.getTotalFuelCharge)(period.gas), totalPositiveCharge);
    var closingBalanceString = Number(closingBalance) < 0
        ? "".concat((0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(closingBalance)))
        : "".concat((0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(closingBalance)));
    var fuels = [
        {
            label: 'electricity',
            color: colors.fuelElec,
            total: (0, billing_1.getTotalFuelCharge)(period.electricity),
            accessibleProgressDescription: copy('accessibleTooltipDescription', {
                spendString: elecSpendString,
                item: 'electricity',
                percentageCharge: elecPercentage,
            }),
            tooltipDescription: copy('tooltipDescription', {
                percentageCharge: elecPercentage,
            }),
        },
        {
            label: 'gas',
            color: colors.fuelGas,
            total: (0, billing_1.getTotalFuelCharge)(period.gas),
            accessibleProgressDescription: copy('accessibleTooltipDescription', {
                spendString: gasSpendString,
                item: 'gas',
                percentageCharge: gasPercentage,
            }),
            tooltipDescription: copy('tooltipDescription', {
                percentageCharge: gasPercentage,
            }),
        },
    ].filter(function (item) { return item.total !== 0; });
    var vatTotal = Number(period.totalCharge.vatCharge.pounds);
    var paymentsReceived = period.payments.reduce(function (total, payment) {
        return Number(payment.credit.pounds) > 0
            ? total + Number(payment.credit.pounds)
            : total;
    }, 0);
    var paymentsReceivedString = (0, core_1.major2DP)((0, core_1.majorToMinor)(paymentsReceived));
    var otherChargesTotal = (0, billing_1.getOtherChargesTotal)(period);
    var otherPercentage = getPercentageString(otherChargesTotal, totalPositiveCharge);
    var creditsTotal = (0, billing_1.getCreditsTotal)(period);
    var vatPercentage = getPercentageString(vatTotal, totalPositiveCharge);
    var dataTable = __spreadArray(__spreadArray([], __read(fuels.map(function (fuel) { return ({
        label: (react_1.default.createElement(IconWithChildren, { Icon: react_1.default.createElement(Icon, { name: fuel.label, color: fuel.color }) }, capitaliseFirstLetter(fuel.label))),
        amount: fuel.total,
        accessibleProgressDescription: fuel.accessibleProgressDescription,
        tooltipDescription: fuel.tooltipDescription,
    }); })), false), [
        {
            label: (react_1.default.createElement(IconWithChildren, { Icon: react_1.default.createElement(Icon, { name: "dots" }) },
                react_1.default.createElement(Copy, { copyKey: "otherCharges" }))),
            amount: otherChargesTotal,
            accessibleProgressDescription: copy('accessibleTooltipDescription', {
                item: 'add-ons',
                spendString: (0, core_1.major2DP)((0, core_1.majorToMinor)(otherChargesTotal)),
                percentageCharge: otherPercentage,
            }),
            tooltipDescription: copy('tooltipDescription', {
                partialCharge: (0, core_1.major2DP)((0, core_1.majorToMinor)(otherChargesTotal)),
                percentageCharge: otherPercentage,
            }),
        },
        {
            label: (react_1.default.createElement(IconWithChildren, { Icon: react_1.default.createElement(Icon, { name: 'dots' }) },
                react_1.default.createElement(Copy, { copyKey: "vat" }))),
            amount: vatTotal,
            accessibleProgressDescription: copy('accessibleTooltipDescription', {
                spendString: (0, core_1.major2DP)((0, core_1.majorToMinor)(vatTotal)),
                percentageCharge: vatPercentage,
                item: 'VAT',
            }),
            tooltipDescription: copy('tooltipDescription', {
                partialCharge: (0, core_1.major2DP)((0, core_1.majorToMinor)(vatTotal)),
                percentageCharge: vatPercentage,
            }),
        },
        {
            label: (react_1.default.createElement(IconWithChildren, { Icon: react_1.default.createElement(Icon, { name: "dots" }) },
                react_1.default.createElement(Copy, { copyKey: "credits" }))),
            amount: -creditsTotal,
            accessibleProgressDescription: copy('tooltipDeductionDescription', {
                deductionAmount: (0, core_1.major2DP)((0, core_1.majorToMinor)(creditsTotal)),
            }),
            tooltipDescription: copy('tooltipDeductionDescription', {
                deductionAmount: (0, core_1.major2DP)((0, core_1.majorToMinor)(creditsTotal)),
            }),
            hideProgressBar: true,
        },
    ], false);
    return {
        totalPositiveCharge: totalPositiveCharge,
        totalCharge: totalCharge,
        dataTable: dataTable,
        paymentsReceivedString: paymentsReceivedString,
        closingBalanceString: closingBalanceString,
        closingBalance: closingBalance,
    };
};
exports.useChargesBreakdown = useChargesBreakdown;
